<template>
  <div class="px-4">
    <div class="tab-contents-header-container">
      <div class="row">
        <div class="col-12 col-sm-4 col-lg-2">
          <h2 class="tab-contents-title">
            Playlists&nbsp;
            <span class="badge badge-space-grey badge-pill badge-tab-contents">
              {{ playlists.length }}
            </span>
          </h2>
        </div>

        <div v-if="!isMobileTablet" class="col-lg-7 playlist-categories">
          <a
            v-if="Object.keys(this.filteredCategories).length"
            class="badge badge-space-grey badge-pill playlist-category"
            :class="{ active: categoryIdFilter === 0 }"
            href="#"
            @click.prevent="onPlaylistCategoryClicked(0)"
          >
            All
          </a>
          <a
            v-for="(categoryId, category) in filteredCategories"
            :key="categoryId"
            class="badge badge-space-grey badge-pill playlist-category"
            :class="{ active: categoryIdFilter === categoryId }"
            href="#"
            @click.prevent="onPlaylistCategoryClicked(categoryId)"
          >
            {{ category }}
          </a>
        </div>
        <div
          class="col-12 col-sm-8 col-lg-3 d-flex flex-column"
          :class="{
            'text-sm-right': !isTablet,
            'tablet-left-align': isTablet,
            'align-items-sm-end': !isTablet,
          }"
        >
          <div class="d-inline-block" :class="{ 'd-tablet-block': isTablet }">
            <div class="form-group form-inline">
              <div class="pr-2 d-inline-block">
                <label for="playlist-tab-content-filter-by"> Filter by: </label>
              </div>
              <div
                class="position-relative d-inline-block"
                :class="{ 'tablet-full-width': isTablet }"
              >
                <input
                  type="text"
                  class="form-control"
                  id="playlist-tab-content-filter-by"
                  placeholder="playlist name..."
                  v-model="filterBy"
                />
                <span
                  v-if="filterBy.length > 0"
                  class="clear-filter-icon"
                  @click="clearFilterBy"
                >
                  <i class="fa fa-times-circle"></i>
                </span>
              </div>
            </div>
          </div>

          <div
            v-if="!isMobileTablet"
            class="d-inline-block"
            :class="{ 'd-tablet-block': isTablet }"
          >
            <div class="form-group form-inline">
              <div class="pr-2 d-inline-block">
                <label for="playlist-tab-content-sort-by"> Sort by: </label>
              </div>
              <div class="custom-select-box-wrapper d-inline-block">
                <select
                  class="form-control"
                  id="playlist-tab-content-sort-by"
                  name="sortBy"
                  v-model="sortBy"
                >
                  <option value="" selected>Newest</option>
                  <option value="a-z">A - Z</option>
                </select>
                <span
                  v-if="sortBy !== ''"
                  class="clear-filter-icon sort-clear-icon"
                  @click="clearSortBy"
                >
                  <i class="fa fa-times-circle"></i>
                </span>
              </div>
            </div>
          </div>

          <div v-if="isMobileTablet" class="d-inline-block mobile-filters-row">
            <div class="row w-100">
              <div class="col-6">
                <div class="form-group">
                  <div>
                    <label for="playlist-tab-content-category">
                      Categories:
                    </label>
                  </div>
                  <div class="custom-select-box-wrapper">
                    <select
                      class="form-control category-select mobile-fullscreen"
                      id="playlist-tab-content-category"
                      name="categories"
                      v-model="categoryIdFilter"
                      @change="
                        onPlaylistCategoryClicked(parseInt($event.target.value))
                      "
                    >
                      <option value="0">All</option>
                      <option
                        v-for="(categoryId, category) in filteredCategories"
                        :key="categoryId"
                        :value="categoryId"
                      >
                        {{ category }}
                      </option>
                    </select>
                    <span
                      v-if="categoryIdFilter > 0"
                      class="clear-filter-icon category-clear-icon"
                      @click="clearCategoryFilter"
                    >
                      <i class="fa fa-times-circle"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <div>
                    <label for="playlist-tab-content-sort-by"> Sort by: </label>
                  </div>
                  <div class="custom-select-box-wrapper">
                    <select
                      class="form-control"
                      id="playlist-tab-content-sort-by"
                      name="sortBy"
                      v-model="sortBy"
                    >
                      <option value="" selected>Newest</option>
                      <option value="a-z">A - Z</option>
                    </select>
                    <span
                      v-if="sortBy !== ''"
                      class="clear-filter-icon sort-clear-icon"
                      @click="clearSortBy"
                    >
                      <i class="fa fa-times-circle"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="lazyloadPlaylists">
      <div
        v-for="playlist in filterSortPlaylists"
        :key="playlist.id"
        class="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2"
      >
        <playlists-tab-card
          :playlist="playlist"
          v-bind:asseturl="asseturl"
        ></playlists-tab-card>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";

export default Vue.component("playlists-tab", {
  name: "playlists-tab",
  data() {
    return {
      filterBy: "",
      sortBy: "",
      categoryIdFilter: 0,
      lazyloadPlaylists: false,
      isMobileTablet: false,
      isTablet: false,
    };
  },

  props: {
    playlists: {
      required: true,
      type: Array,
    },
    categories: {
      required: true,
      type: Object,
    },
    asseturl: {
      required: true,
      type: String,
    },
  },

  computed: {
    filterSortPlaylists() {
      let filterSortedArray = this.playlists.slice();

      if (
        this.filterBy !== null &&
        this.filterBy === "" &&
        this.sortBy === null &&
        this.sortBy === "" &&
        this.categoryIdFilter === null &&
        this.categoryIdFilter === 0
      ) {
        return this.playlists;
      }

      if (this.filterBy !== null && this.filterBy !== "") {
        filterSortedArray = filterSortedArray.filter((playlist) => {
          return (
            playlist.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) >
            -1
          );
        });
      }

      if (this.sortBy !== null && this.sortBy !== "") {
        switch (this.sortBy) {
          case "a-z":
            filterSortedArray = filterSortedArray.sort((a, b) => {
              return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
            });
            break;
          default:
            break;
        }
      }

      if (this.categoryIdFilter !== null && this.categoryIdFilter > 0) {
        filterSortedArray = filterSortedArray.filter((playlist) => {
          return playlist.category_id === this.categoryIdFilter;
        });
      }

      return filterSortedArray;
    },
    // Only show categories that are currently in use (i.e. playlist has category assigned to it)
    filteredCategories() {
      return Object.fromEntries(
        Object.entries(this.categories).filter(([, categoryId]) => {
          return this.playlists.some((playlist) => {
            return playlist.category_id === categoryId;
          });
        }),
      );
    },
  },

  methods: {
    onPlaylistsTabClicked() {
      this.lazyloadPlaylists = true;
    },
    onPlaylistCategoryClicked(categoryId) {
      this.categoryIdFilter = categoryId;
    },
    updateIsMobileTablet() {
      this.isMobileTablet = window.innerWidth < 992;
      this.isTablet = window.innerWidth >= 768 && window.innerWidth < 992;
    },
    clearFilterBy() {
      this.filterBy = "";
    },
    clearCategoryFilter() {
      this.categoryIdFilter = 0;
    },
    clearSortBy() {
      this.sortBy = "";
    },
  },

  created() {
    playerService.$on("on-playlists-tab-click", this.onPlaylistsTabClicked);
  },
  mounted() {
    this.updateIsMobileTablet();
    playerService.$on("reset-filters", (caller) => {
      // The below resetFilters caller occurs when albums are being searched. We want
      // to persist all playlist filters when searching albums. Otherwise reset the filters
      if (caller !== "resetFilters") {
        this.categoryIdFilter = 0;
        this.filterBy = "";
        this.sortBy = "";
      }
    });
    window.addEventListener("resize", this.updateIsMobileTablet);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsMobileTablet);
  },
});
</script>
